import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsDocksQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LogisticsDockDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LogisticsDockDocumentSortInput> | Types.LogisticsDockDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsDocksQuery = { __typename?: 'Query', logisticsDocks?: { __typename?: 'LogisticsDocksConnection', totalCount: number, nodes?: Array<{ __typename?: 'LogisticsDockDocument', id: string, tenantId: string, dockId: string, name: string, isActive: boolean, loadsPerDay?: number | null, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsDockDocumentFieldsFragment = { __typename?: 'LogisticsDockDocument', id: string, tenantId: string, dockId: string, name: string, isActive: boolean, loadsPerDay?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsDockDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDockDocumentFields on LogisticsDockDocument {
  id
  tenantId
  dockId
  name
  isActive
  loadsPerDay
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsDockDocumentFields"});
export const GetAllLogisticsDocksDocument = new TypedDocumentString(`
    query GetAllLogisticsDocks($where: LogisticsDockDocumentFilterInput, $order: [LogisticsDockDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsDocks(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsDockDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsDockDocumentFields on LogisticsDockDocument {
  id
  tenantId
  dockId
  name
  isActive
  loadsPerDay
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsDocks: build.query<GetAllLogisticsDocksQuery, GetAllLogisticsDocksQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsDocksDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsDocksQuery, useLazyGetAllLogisticsDocksQuery } = injectedRtkApi;
